import React, {useState} from 'react';
import { rgba, tint, shade } from 'polished';
import styled from 'styled-components'
import * as Clrs from '../../src/js/colors'
import {Painting, Year} from '../components/painting';
import {Modal, CloseModal} from '../components/modal';

import d1 from '../images/portfolioItems/spiritWeb.jpg';
import d2 from '../images/portfolioItems/bethelLogo.jpg';
import d3 from '../images/portfolioItems/vata.jpg';
import d4 from '../images/portfolioItems/retro.jpg';
import d5 from '../images/portfolioItems/coresiteWeb.jpg';
import d6 from '../images/portfolioItems/mid.jpg';
import d7 from '../images/portfolioItems/retrologo.jpg';
import d8 from '../images/portfolioItems/mod.jpg';
import o3 from '../images/william.jpg';
import o4 from '../images/crabapple.jpg';


function DesignWork(props) {
    const [showModal, setShowModal] = useState(null);
    const [selectedImg, setSelectedImg] = useState(null);
    const [descriptionText, setDescriptionText] = useState("");
    function closeModal(){
      setShowModal(false);
    }
    function openModal(img) {
      setShowModal(true);
      setSelectedImg(img);
    }
    return (
        <>
        <Year yr="Web design">
        <Painting txt="RetroSpec" wide onClick={()=>{openModal(d4); setDescriptionText("Retrospec Web App || Work in progress"); }} closeFunc={()=>setShowModal(false)}>
            <img alt="txt" src={d4} />
          </Painting>
          <Painting txt="Model Suite" wide onClick={()=>{openModal(d8); setDescriptionText("InEight Model Suite || Model viewer design"); }} closeFunc={()=>setShowModal(false)}>
            <img alt="txt" src={d8} />
          </Painting>
          <Painting txt="Midland's Choice" narrow onClick={()=>{openModal(d6); setDescriptionText("Midland's Choice Web"); }} closeFunc={()=>setShowModal(false)}>
            <img alt="txt" src={d6} />
          </Painting>
          <Painting txt="Coresite"  onClick={()=>{openModal(d5); setDescriptionText("Coresite Web"); }} closeFunc={()=>setShowModal(false)}>
            <img alt="txt" src={d5} />
          </Painting>
          <Painting txt="The Old Crabapple" onClick={()=>{openModal(d1); setDescriptionText("The Old Crabapple || Ink on paper || dimensions"); }} closeFunc={()=>setShowModal(false)}>
            <img alt="txt" src={d1} />
          </Painting>
          </Year>
          <Year yr="Motion">
            <Painting txt="The Old Crabapple" narrow onClick={()=>{openModal(o4); setDescriptionText("The Old Crabapple || Ink on paper || dimensions"); }} closeFunc={()=>setShowModal(false)}>
              <img alt="txt" src={o4} />
            </Painting>
          </Year>
          <Year yr="Branding">
            <Painting txt="Retrospec" wide onClick={()=>{openModal(d7); setDescriptionText("Retrospec"); }} closeFunc={()=>setShowModal(false)}>
              <img alt="txt" src={d7} />
            </Painting>
            <Painting txt="The Old Crabapple" wide onClick={()=>{openModal(d3); setDescriptionText("The Old Crabapple || Ink on paper || dimensions"); }} closeFunc={()=>setShowModal(false)}>
              <img alt="txt" src={d3} />
            </Painting>
          </Year>
       
      <Modal in={showModal}  desc={descriptionText} closebtn={<CloseModal onClick={()=>setShowModal(false)}>Close</CloseModal>}>
        <img src={selectedImg} />
      </Modal>
      </>
    );
  }



  export {DesignWork};